import styled from 'styled-components';

import { Heading } from '@cognite/cogs-core-v11/tokens/typography/typography.tsx';

export const ToggleRowHeading = styled(Heading).attrs({
  level: 6,
})<{
  $isUpdated: boolean;
}>`
  ${({ $isUpdated }) =>
    $isUpdated && 'color: var(--cogs-border--status-warning--strong)'}
`;
